import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, CircularProgress, Typography } from '@mui/material';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import DealCard from '../components/DealCard';

const SingleVenuePage = () => {
  const { venueId } = useParams();
  const [venue, setVenue] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVenue = async () => {
      try {
        const venueDoc = await getDoc(doc(db, 'venues', venueId));
        if (venueDoc.exists()) {
          setVenue({ id: venueDoc.id, ...venueDoc.data() });
        } else {
          setError('Venue not found');
        }
      } catch (err) {
        console.error('Error fetching venue:', err);
        setError('Failed to load venue');
      } finally {
        setLoading(false);
      }
    };

    fetchVenue();
  }, [venueId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !venue) {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Typography color="error" align="center">
          {error || 'Venue not found'}
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 4, mb: 4 }}>
      <DealCard venue={venue} />
    </Container>
  );
};

export default SingleVenuePage;